import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/Home/HomeView.vue'
import AboutView from '../views/About/AboutView.vue'
import NewsView from '../views/News/NewsView.vue'
import ProductView from '../views/Product/ProductView.vue'
import SpecialView from '../views/Special/SpecialView.vue'
import CaseView from '../views/Case/CaseView.vue'
import Login from '../views/Admin/Login.vue'
import Admin from '../views/Admin/Admin.vue'
import XueLiangLogin from '../views/DingLogin/XueLiangLogin.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/index.html',
    redirect: '/' // 重定向到根路径
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/product',
    name: 'product',
    component: ProductView
  },
  {
    path: '/special',
    name: 'special',
    component: SpecialView
  },
  {
    path: '/case',
    name: 'case',
    component: CaseView
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/xueliang-login',
    name: 'xueliangLogin',
    component: XueLiangLogin
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（如浏览器前进后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到页面顶部
    return { x: 0, y: 0 }
  }
})

// Token 验证函数
function validateToken() {
  const token = localStorage.getItem('topeak_token')
  const user = localStorage.getItem('topeak_user')

  if (!token || !user) {
    return false
  }

  try {
    // 解析用户信息，检查token是否有效
    const userData = JSON.parse(user)
    if (!userData.username) {
      return false
    }

    // 可以在这里添加token过期时间检查
    // 如果后端返回了过期时间，可以在这里验证

    return true
  } catch (error) {
    return false
  }
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查token有效性
    if (!validateToken()) {
      // 清除无效的登录状态
      localStorage.removeItem('topeak_token')
      localStorage.removeItem('topeak_user')
      store.commit('setAuth', null)

      // 跳转到登录页面
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

// 在路由切换完成后确保滚动到顶部
router.afterEach(() => {
  // 延迟执行，确保页面内容已渲染
  setTimeout(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // 平滑滚动
    })
  }, 100)
})

export default router
